package com.ustadmobile.core.db.dao

object CourseAssignmentMarkDaoCommon {

    const val ARG_FILTER_RECENT_SCORES = 1

    const val ARG_FILTER_ALL_SCORES = 0

}